import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from './../AuthContext';

function LoginPage({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";
  const { login } = useAuth();

  const [isLoggedFalse, setIsLoggedFalse] = useState(false);
  const [isLogged, setIsLogged] = useState(true);
  const [errorMessage, setErrorMessage] = useState('Неправильный логин или пароль');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const loginValue = event.target.auth_login.value;
    const passwordValue = event.target.auth_password.value;
    authorization(loginValue, passwordValue);
  };

  const authorization = (loginValue, passwordValue) => {
    setIsSubmitting(true);
    const dataToSend = { login: loginValue, password: passwordValue };
    fetch(`${process.env.REACT_APP_BASE_URL}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        setIsSubmitting(false);
        if (data.state) {
          login(data);
          const user = { login: loginValue, password: passwordValue };
          localStorage.setItem('user', JSON.stringify(user));
          setIsLoggedIn(true);

          if ((from === '/admin' || from === '/catalog' || from === '/users') && data.isadmin == 0) {
            setIsLogged(false);
            setIsLoggedFalse(true);
            setErrorMessage('У Вас недостаточно прав');
          } else {
            setIsLogged(true);
            navigate(from);
          }
        } else {
          setIsLoggedFalse(true);
          setIsLogged(false);
          setErrorMessage('Неправильный логин или пароль');
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        setIsLogged(false);
        setIsLoggedFalse(true);
        setErrorMessage('Не удалось подключиться к серверу. Проверьте соединение и попробуйте снова.');
        console.error("Error sending POST request:", process.env.REACT_APP_BASE_URL + " " + error);
      });
  }

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem('user'));
    if (savedUser) {
      authorization(savedUser.login, savedUser.password);
    } else {
      setIsLogged(false);
    }
  }, []);

  return (
    <div>
      {!isLogged ? (
        <div style={styles.page}>
          <div style={styles.card}>
            <div style={styles.header}>
              <div style={styles.iconCircle}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <h1 style={styles.title}>Вход в систему</h1>
              <p style={styles.subtitle}>Введите данные для авторизации</p>
            </div>

            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.field}>
                <label style={styles.label}>Логин</label>
                <input
                  name="auth_login"
                  type="text"
                  placeholder="Введите логин"
                  style={styles.input}
                  autoComplete="username"
                />
              </div>

              <div style={styles.field}>
                <label style={styles.label}>Пароль</label>
                <input
                  name="auth_password"
                  type="password"
                  placeholder="Введите пароль"
                  style={styles.input}
                  autoComplete="current-password"
                />
              </div>

              {isLoggedFalse && (
                <div style={styles.errorBox}>
                  {errorMessage}
                </div>
              )}

              <button type="submit" style={styles.button} disabled={isSubmitting}>
                {isSubmitting ? 'Вход...' : 'Войти'}
              </button>
            </form>
          </div>
        </div>
      ) : ""}
    </div>
  );
}

const styles = {
  page: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f9fafb',
    zIndex: 10000,
    fontFamily: 'inherit',
  },
  card: {
    width: '100%',
    maxWidth: '380px',
    background: '#ffffff',
    borderRadius: '20px',
    padding: '40px 32px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    margin: '16px',
    boxSizing: 'border-box',
  },
  header: {
    textAlign: 'center',
    marginBottom: '28px',
  },
  iconCircle: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    background: '#eff6ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#111827',
    margin: '0 0 6px 0',
  },
  subtitle: {
    fontSize: '13px',
    color: '#9ca3af',
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
  },
  input: {
    padding: '12px 14px',
    fontSize: '15px',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    outline: 'none',
    boxSizing: 'border-box',
    width: '100%',
    transition: 'border-color 0.15s',
  },
  errorBox: {
    fontSize: '13px',
    color: '#ef4444',
    background: '#fef2f2',
    padding: '10px 12px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  button: {
    marginTop: '4px',
    padding: '13px',
    fontSize: '15px',
    fontWeight: 600,
    color: '#ffffff',
    background: '#3b82f6',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'background 0.15s',
  },
};

export { LoginPage };